const baseViewFactory = require('./view');
module.exports = baseViewFactory({
    events: {
        'tap .checkinF_iframe_close': 'onCloseIframeContainer',
        'tap .seatmap_checkin_checkout_button': 'confirmSeatSelection',
    },
    renderIframe() {
        this.renderIframeTemplate();
        const $iframe = this.$cachedSelectors.userInteractionLayer.find(`#${this.userInteractionIframeId}`);
        let iframeOptions = {};

        if (this.isCheckIn()) {
            iframeOptions = {customFeedback: true, genericError: true};
        } else {
            this.togglePaymentForm({
                show: false,
            });
        }
        window.addEventListener('message', Odigeo._.partial(this.messageReceivedFromIframe, _, $iframe, iframeOptions).bind(this), false);

        this.toggleInteractionLayer(true);
        if (this.isCheckIn()) {
            this.toggleIframeContainer(true);
        }

        Odigeo.trigger(`${this.id}:onCheckoutInteractionNeeded`);
    },
    toggleIframeContainer(isShowing) {
        this.$cachedSelectors.userInteractionLayer.find('.user_interaction_wrapper').toggleClass('opened', isShowing);
    },
    onCloseIframeContainer() {
        this.closeIframeContainer();
        this.managePaymentRetry({customFeedback: true});
    },
    closeIframeContainer() {
        this.toggleIframeContainer(false);
    },
});
